import PropTypes from 'prop-types';

export const OrganizationProps = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  parent_id: PropTypes.string,
  path: PropTypes.arrayOf(PropTypes.string)
});

// Setup a recursive tree
OrganizationProps.children = PropTypes.arrayOf(OrganizationProps);

export const OrgOptionProps = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  org: OrganizationProps.isRequired
});

export const OrganizationDefaults = {
  id: '',
  name: '',
  parent_id: null,
  children: [],
  path: []
};
